import { Card } from 'antd';
import { useState } from 'react';
import { getPriceText } from '@zorba-shared/core/Services/textService';
import { EntitiesTable } from '../EntitiesTable';
import { MailingAddressesTable } from '../MailingAddressesTable';
import { Spinner } from '../../../../../../components/layout';
import { AcquisitionsChart } from '../AcquisitionsChart';
import { OverviewHeader } from './Header';
import { TAB_TO_DATA_KEY } from './Header/constants';
import {
  useGetAccountEntities,
  useGetAccountStats,
} from '../../../../../../queries/Account';
import { showErrorToast } from '../../../../../../services/notificationsService';

import './index.scss';

export const Overview = ({
  postgresId,
  appliedFilters,
  accountDetailsData,
  isDetailsLoading,
}) => {
  const [activeTab, setActiveTab] = useState('1');

  const {
    data: accountEntities,
    isLoading: isLoadingEntities,
  } = useGetAccountEntities({ postgresId });

  const {
    data: accountStatsData,
    isLoading: isStatsLoading,
    isError: isStatsError,
  } = useGetAccountStats({ postgresId, appliedFilters });

  if (isStatsError) {
    showErrorToast('Fetching account stats failed!');
  }

  return (
    <>
      {!isDetailsLoading ? (
        <div className="stats">
          <Card>
            <h3>Acquisitions</h3>
            <h1>{accountDetailsData?.acquiredPropertiesCount || 0}</h1>
          </Card>
          <Card>
            <h3>Dispositions</h3>
            <h1>{accountDetailsData?.soldPropertiesCount || 0}</h1>
          </Card>
          <Card>
            <h3>Acquisitions GMV</h3>
            <h1>
              {getPriceText(accountDetailsData?.totalTransactionsAmount || 0)}
            </h1>
          </Card>
          <Card>
            <h3>Inter-Company Transfers</h3>
            <h1>{accountDetailsData?.portfolioAggregationsCount || 0}</h1>
          </Card>
        </div>
      ) : (
        <Spinner />
      )}
      <div className="entities-and-chart-container">
        <Card
          title={`Associated Entities (${
            accountEntities?.entities?.length || 0
          })`}
          className="entities-card"
        >
          <EntitiesTable
            isLoading={isLoadingEntities}
            accountDetailsData={accountEntities}
          />
        </Card>
        <Card
          title={
            <OverviewHeader activeTab={activeTab} setActiveTab={setActiveTab} />
          }
          className="acquisitions-chart-card"
        >
          <AcquisitionsChart
            isLoading={isStatsLoading}
            accountStatsData={accountStatsData}
            dataKey={TAB_TO_DATA_KEY[activeTab]}
          />
        </Card>
      </div>
      <Card
        title="Associated mailing addresses"
        className="mailing-addresses-card"
      >
        <MailingAddressesTable postgresId={postgresId} />
      </Card>
    </>
  );
};
